import COUNTRIES from '../countries.translations'

import { articleFigure } from './articleFigure'
import { articleMetal } from './articleMetal'
import translations from './story06.content'
import type { Article } from './types'

const t = translations
const dir = '/mine-my-phone/images/articles/story06'
const figure = articleFigure(dir)

export const story06: Article = {
  id: 6,
  slug: 'interview-cristina-dorador-south-america-extractivism',
  order: 6,
  title: t.title,
  excerpt: t.excerpt,
  image: `${dir}/01.jpg`,
  imageCaption: [...t.captions[0]],
  metal: articleMetal('lithium'),
  author: 'Paula Díaz Levi',
  // Antofagasta, not the Atacama Desert — story03 pins that, and stacked markers hide
  // each other.
  region: [
    {
      name: t.regionName,
      country: COUNTRIES.chile,
      coordinates: [-70.4, -23.65],
      impact: 'environmental',
    },
  ],
  impactList: ['environmental', 'geopolitical'],
  content: {
    sections: [
      { type: 'prose', blocks: [...t.prose[0]] },
      figure('02.jpg', t.captions[1]),
      { type: 'prose', blocks: [...t.prose[1]] },
      { type: 'quote', ...t.quotes[0] },
      { type: 'prose', blocks: [...t.prose[2]] },
      figure('03.jpg', t.captions[2]),
      { type: 'prose', blocks: [...t.prose[3]] },
    ],
  },
}
